import headBox from "./onlineClass/head.vue";
import idebox from "./onlineClass/idebox.vue";
import checkpoint from "./onlineClass/checkpoint.vue";
import store from "../store";
import { mapGetters } from "vuex";
import AdventureManager from "../manager/AdventureManager";
import OperateDom from "../manager/OperateDom";
import VueQr from "vue-qr";
import Logger from "../utils/Logger";
import { videoPlayer } from 'vue-video-player';
import 'video.js/dist/video-js.css';
import Const from "../const/Const";
import Cookies from 'js-cookie';
import OSS  from "ali-oss";

export default {
    data() {
        return {
            canDragCodeIndexDialog: false,
            firstVideoVisible: false,
            loading: false,
            createURL: process.env.GAME_CREATE_URL,
            IMG_BASE_URL: process.env.IMG_BASE_URL,
            flag: true,
            playVideoShow: true,
            ord: 0,
            blocklyOrCode: true,
            config: {
                logo: process.env.CDN_STATIC_URL + "icode.png",
            },
            zoomScale: true,
            elapseTimeTxt: 0, // 倒计时时间文本
            timerId: 0,
            classSettingVideo: true, // 班级里的视频解析开关设置
            showElapse: false, // 显示倒计时
            showEndElapse: false, // 倒计时结束
            showUnVip: false, // 显示非VIP
            showUnConfig: false, // 显示没有配置内容的
            countTotalSecs: 3000,
            dialogVisible: false,
            cameraVisible: false,
            playerOptions: {
                autoplay: false,
                muted: false,
                language: 'en',
                width: '800',
                height: '426',
                playbackRates: [0.7, 1.0, 1.5, 2.0],
                sources: [{
                    type: "video/mp4",
                    src: "",
                }]
            },
            canPlay: false,
            zindex: 20000,
            ossClient: new OSS({
                region: "oss-cn-shanghai",
                bucket: "screen-snapshots",
                accessKeyId: "LTAI5tDwMoFYSThRBBkcPdNj",
                accessKeySecret: "zireBMRjURvQZASBM8IPVunw0Wbml9"
            }),

            ossHeaders: {
                // 指定Object的存储类型。
                'x-oss-storage-class': 'Standard',
                // 指定Object的访问权限。
                'x-oss-object-acl': 'private',
                'x-oss-forbid-overwrite': 'true',
            }
        };
    },
    components: {
        idebox,
        headBox,
        checkpoint,
        VueQr,
        videoPlayer,
    },
    //VideoWaitTime-视频等待时间-数值
    //VideoURL-视频地址-字符串
    //BgAnimation-背景动画-字符串
    created() {},
    mounted() {
        // 初始化和游戏交互的类
        window.adventureManager = AdventureManager.init(this);

        // 刚进入界面时显示蒙版 (等游戏加载好了, 再移除这个蒙版)
        // store.state.maskBox = true;
        store.state.isLoading = true;
        // 载入文字变换周期
        this._loadingTextChangeInterval = 0.5;
        this._loadingTextChangeTimer = 0;
        this._loadingTextDotNumber = 3;
        // 添加事件
        this.ideResize();
        this.$nextTick(() => {
            // 窗口尺寸变化事件
            window.addEventListener("resize", () => {
                $(".codeIndexDialog_txt_zh").css("top", 0);
                $(".codeIndexDialog_txt_en").css("top", 0);
                $(".codeIndexDialog_txt_fr").css("top", 0);
                $(".codeIndexDialog_txt_sp").css("top", 0);
                this.ideResize();
            });
            // 窗口点击事件
            window.addEventListener("click", () => {
                // 如果 用户在游戏内 且 ace被蒙版蒙住，游戏画布获取焦点
                if (window._inGame && store.state.ideMask) {
                    AdventureManager.toFront_focusOnCanvas();
                }
            });
        });
        if (store.state.lang == "en") {
            this.zhShow = false;
        } else {
            this.zhShow = true;
        }


        store.state.imagesLoaded = true;
        // 开始定时任务
        this.startUpdate();

        let gameId = this.$route.query.game;

        this.cameraVisible = false;

        // To be deleted
        if ([123003, 123004, 123005, 123006].indexOf(Math.floor(gameId)) != -1) {
            this.cameraVisible = true;
            this.getCameraHandler();
        }
        
        if ([26116611].indexOf(Math.floor(gameId)) != -1 && (localStorage.getItem("firstVideoVisible") == null)) {
            this.firstVideoVisible = true;
            localStorage.setItem('firstVideoVisible', true)
        }

        // 通过服务器配置修改信息
        AdventureManager.queryGameInfo(()=>{
            this.courseTitleTxt = store.state.courseTitleTxt;

            if(store.state.camera){
                this.cameraVisible = true;
                this.getCameraHandler();
            };

        })

        // 多语言模块
        document.querySelector('#gameContent').classList.add(store.state.lang);

        // 通过Cookie来获取home页面的设置，false-关闭，其他-开放
        this.classSettingVideo = Cookies.get("classSettingVideo");
    },

    destroyed() {
        // 停止定时任务
        this.stopUpdate();
    },

    methods: {
        mousedownDivHandler(e) {
            e = e || window.event;
            this.x = e.clientX - cameraVideoContainer.offsetLeft;
            this.y = e.clientY - cameraVideoContainer.offsetTop;
            this.dragFlag = true;
            this.mousemoveDivHandler(e);
            cameraVideoContainer.style.cursor = "pointer";

        },
        mousemoveDivHandler(e) {
            if (this.dragFlag) {
                e = e || window.event;
                cameraVideoContainer.style.left = e.clientX - this.x + "px";
                cameraVideoContainer.style.top = e.clientY - this.y + "px";
            }
        },
        mouseupDivHandler(event) {
            this.dragFlag = false;
            cameraVideoContainer.style.cursor = "default";
        },
        getCameraHandler() {
            let constraints = { video: { width: 308, height: 192 } };
            if (navigator.mediaDevices && navigator.mediaDevices.getUserMedia) {
                navigator.mediaDevices.getUserMedia(constraints).then((stream) => {
                    this.videoSuccess(stream);
                }).catch((error) => {
                    this.videoError(error);
                });
            } else if (navigator.webkitGetUserMedia) {
                navigator.webkitGetUserMedia(constraints, (stream) => {
                    this.videoSuccess(stream);
                }, (error) => {
                    this.videoError(error);
                });
            } else if (navigator.mozGetUserMedia) {
                navigator.mozGetUserMedia(constraints, (stream) => {
                    this.videoSuccess(stream);
                }, (error) => {
                    this.videoError(error);
                });
            } else if (navigator.getUserMedia) {
                navigator.getUserMedia(constraints, (stream) => {
                    this.videoSuccess(stream);
                }, (error) => {
                    this.videoError(error);
                });
            } else {
                this.videoError("no meida found!");
            }
        },
        videoSuccess(stream) {
            var CompatibleURL = window.URL || window.webkitURL;
            //将视频流设置为video元素的源
            //video.src = CompatibleURL.createObjectURL(stream);
            cameraVideo.srcObject = stream;
            cameraVideo.play();
            cameraVideo.ontimeupdate = () => {}

            // 定时传输截图到阿里云

            window.setInterval(() => {
                this.uploadImagesToOSS();
            }, 60 * 1000); // every 60 seconds

        },

        async uploadImagesToOSS () {
            const context = hideCanvas.getContext("2d");
            if (cameraVideo.videoWidth && cameraVideo.videoHeight) {
                hideCanvas.width = cameraVideo.videoWidth;
                hideCanvas.height = cameraVideo.videoHeight;

                context.drawImage(cameraVideo, 0, 0);

                hideCanvas.toBlob((blob) => {
                    if(blob == null) return;
                    let gameId = window.bridge.getCurrentGameId();
                    let userId = Cookies.get("USERID");
                    let timestamp = Date.now();
        
                    const storeDir = `${gameId}/${userId}/${timestamp}.png`;
                    this.ossClient.put(storeDir, blob);
                });

            }
           
        },
        videoError(error) {
            console.log("videoError:" + error);
        },
        setExitMode() {
            this.toggleDiv(1);
        },
        playVideoHandler() {
            if (!this.canPlay) {
                return;
            }
            this.dialogVisible = true;
            if (this.$refs.videoPlayer && this.$refs.videoPlayer.player) {
                this.$refs.videoPlayer.player.play();
            }
        },
        handleClose() {
            if (this.$refs.videoPlayer && this.$refs.videoPlayer.player) {
                this.$refs.videoPlayer.player.pause();
            }
            this.dialogVisible = false;
        },
        toggleDiv(value) {
            if (value == 1) {
                // 没有配置。不需要倒计时，UI需要制作
                this.showUnConfig = true;
                this.showUnVip = false;
                this.showElapse = false;
                this.showEndElapse = false;
                return;
            }
            if (value == 2) {
                // 非vip会员不能观看，UI需要处理
                this.showUnConfig = false;
                this.showUnVip = true;
                this.showElapse = false;
                this.showEndElapse = false;
                return;
            }
            if (value == 3) {
                // 显示倒计时
                this.showUnConfig = false;
                this.showUnVip = false;
                this.showElapse = true;
                this.showEndElapse = false;

                // 如果是教师账号，直接解锁
                if(store.state.userType == 2){
                    this.showElapse = false;
                    this.showEndElapse = true;
                    this.canPlay = true;
                }
                return;
            }
            if (value == 4) {
                // 倒计时结束
                this.showUnConfig = false;
                this.showUnVip = false;
                this.showElapse = false;
                this.showEndElapse = true;
                return;
            }
        },
        setConfigImg() {
            this.showUnConfig = true;
            this.showUnVip = false;
            this.showElapse = false;
            this.showEndElapse = false;
            clearInterval(this.timerId);
        },

        getIDEGameLevelConfig() {
            return this.$refs.idebox.GameLevelSetting;
        },

        setUseDefaultCode(boolen) {
            this.$refs.idebox.isUseDefaultCode = boolen;
        },

        // 会员视频倒计时功能
        startCountDown() {
            let obj = window.bridge.getCurrentLevelData();
            // Logger.log("start startCountDown", obj["VideoWaitTime"]);
            if (!obj["VideoWaitTime"] || obj["VideoWaitTime"] == -1) {
                // 没有配置。不需要倒计时，UI需要制作
                clearInterval(this.timerId);
                this.timerId = 0;
                this.toggleDiv(1);
                return;
            }
            // 班级设置里未打开视频，则无法查看视频
            if (this.classSettingVideo == 'closed') {
                clearInterval(this.timerId);
                this.timerId = 0;
                this.toggleDiv(1);
                return;
            }

            if (this.isVip <= 0) {
                // 非vip会员不能观看，UI需要处理
                Logger.log("非vip会员不能观看");
                clearInterval(this.timerId);
                this.toggleDiv(2);
                return;
            }
            // 开始倒计时
            this.playerOptions.sources[0].src = process.env.CDN_STATIC_URL + "t-video/" + window.bridge.getCurrentLevelData()['VideoURL'];
            this.countTotalSecs = parseInt(obj["VideoWaitTime"]);
            // 如果已经存在倒计时。清除并重新计时
            if (this.timerId > 0) {
                clearInterval(this.timerId);
                this.timerId = 0;
            }
            this.canPlay = false; // 定时器控制可以播放
            this.toggleDiv(3);

            this.timerId = setInterval(() => {
                // 如果倒计时结束，
                if (this.countTotalSecs <= 0) {
                    clearInterval(this.timerId);
                    this.elapseTimeTxt = "00:00";
                    this.timerId = 0;
                    this.canPlay = true;
                    this.toggleDiv(4);
                    return;
                }
                this.countTotalSecs = this.countTotalSecs - 1;
                let mins = Math.floor(this.countTotalSecs / 60); // 分钟
                let secs = this.countTotalSecs % 60; // 秒
                this.elapseTimeTxt = (mins < 10 ? '0' + mins : mins) + ":" + (secs < 10 ? '0' + secs : secs);
            }, 1000);
        },

        // To be deleted
        initTxt() {
            this.$i18n.locale = AdventureManager.getLanguage();

            // 直接使用字段
            if(store.state.gameId > 20000000) return;
            if(store.state.gameId > 20000 && store.state.gameId < 30000) return;

            let courseTitleTxt = this.$t("course_" + store.state.gameId);

            if(store.state.courseTitleTxt == "course_" + store.state.gameId){
                switch (store.state.gameId % 100) {
                    case "01":
                        courseTitleTxt = this.$t("course_blockly_1");
                        break;
                    case "02":
                        courseTitleTxt = this.$t("course_blockly_2");
                        break;
                    case "11":
                        courseTitleTxt = this.$t("course_python_1");
                        break;
                    case "12":
                        courseTitleTxt = this.$t("course_python_2");
                        break;
                    default:
                        courseTitleTxt = this.$t("course_competition");
                }
            }

            store.state.courseTitleTxt = courseTitleTxt;
        },

        //
        ideResize() {
            this.screenWidth = document.body.clientWidth;
            this.screenHeight = document.body.clientHeight;
      
            if(this.screenWidth >= 1440 & this.screenHeight >= 900){
                $(".chkBOx").css('transform', 'scale(1)');
                $(".bigImg").css('transform', 'translateX(-50%) scale(1)');
        
                $(".codeIndexDialogMask").css('transform', 'scale(1)');
                $(".successDialog").css("transform", "scale(1)");
                $(".explainDialog").css("transform", "translate(-50%,-50%) scale(1)");
            } else {
                let scale = Math.min(this.screenWidth/1440, this.screenHeight/900);
                            
                $(".chkBOx").css('transform', `scale(${scale})`);
                $(".bigImg").css('transform', `translateX(-50%) scale(${scale})`);
        
                $(".codeIndexDialogMask").css('transform', `scale(${scale})`);
                $(".successDialog").css("transform", `scale(${scale})`);
                $(".explainDialog").css("transform",  `translate(-50%,-50%) scale(${scale})`);
                }

        },
        // 操作说明图片轮播
        leftArrow() {
            let transord = this.ord - 1;
            transord = transord < 0 ? store.state.imgList.length - 1 : transord;
            this.goImg(transord);
        },
        rightArrow() {
            let transord = this.ord + 1;
            transord = transord > store.state.imgList.length - 1 ? 0 : transord;
            this.goImg(transord);
        },

        goImg(transOrd) {
            let outOrd = this.ord;
            this.ord = transOrd;
            if (this.ord > store.state.imgList.length - 1) this.ord = 0;
            let img = $(".imgBox img");
            img.eq(outOrd).animate({ opacity: 0 }, 1000);
            img.eq(this.ord).animate({ opacity: 1 }, 1000);
        },
        delImg() {
            OperateDom.getStyle(
                this.$refs.idebox.$refs.questionMark,
                `${this.IMG_BASE_URL}questionMark.png`
            );
            store.state.imgShow = false;
        },
        startUpdate() {
            this.stopUpdate();
            let dt = 1000 / 30;
            this.updateTaskId = setInterval(() => this.update(dt / 1000), dt);
        },
        checkLang(item) {
            store.state.loadingText = this.$t("loading_txt") + "...";
            this.$refs.checkLangBg.style.display = "block";
            let language = "he";
            if (item == "1") {
                this.setLangs("he", "92", "172");
                language = "he";
                AdventureManager.tellGameInit("he");
            }
            if (item == "2") {
                this.setLangs("ar", "319", "172");
                language = "ar";
                AdventureManager.tellGameInit("ar");
            }
            this.$i18n.locale = language;
        },
        checkLangs(item) {
            store.state.loadingText = this.$t("loading_txt") + "...";
            this.$refs.checkLangBg.style.display = "block";
            let language = "he";
            if (store.state.firstPlayVideo == "1") {
                store.state.videoShow = true;
                this.openVideo();
            }
            if (item == "1") {
                this.setLangs("he", "44", "179");
                language = "he";
                AdventureManager.tellGameInit("he");
            }
            if (item == "2") {
                this.setLangs("ar", "221", "179");
                language = "ar";
                AdventureManager.tellGameInit("ar");
            }
            if (item == "3") {
                this.setLangs("en", "398", "179");
                language = "en";
                AdventureManager.tellGameInit("en");
            }
            this.openVideo();
            this.$i18n.locale = language;
        },
        setLangs(lang, left, top) {

            AdventureManager.setLanguage(lang);
            this.$i18n.locale = lang;

            this.$refs.checkLangBg.style.left = left + "px";
            this.$refs.checkLangBg.style.top = top + "px";
        },
        stopUpdate() {
            if (this.updateTaskId == null) {
                return;
            }
            clearInterval(this.updateTaskId);
        },
        // 模仿游戏组件的 update 生命期钩子
        update(dt) {
            // 更新ace中选中行的背景色
            if (window._code_is_running) {
                $(".ace_active-line").css(
                    "background",
                    window._run_code_has_exception ? "#ff4444" : "#4444ff"
                );
            }

            // 更新载入文字
            this._loadingTextChangeTimer += dt;
            if (
                this._loadingTextChangeTimer >= this._loadingTextChangeInterval
            ) {
                this._loadingTextChangeTimer = 0;
                this._loadingTextDotNumber =
                    (this._loadingTextDotNumber + 1) % 3;
                store.state.loadingText =
                    this.$t("loading_txt") +
                    ".".repeat(
                        this._loadingTextDotNumber == 0 ?
                        3 :
                        this._loadingTextDotNumber
                    );
            }

            // 子组件的update
            this.$refs.headBox.update(dt);
            this.$refs.idebox.update(dt);
        },

        // 获取语言
        getLan() {
            return AdventureManager.getLanguage();
        },
        // 修改语言
        changeLanguage() {
            AdventureManager.sendToGame("changeLanguage");
        },
        langDiologCancel() {
            store.state.checkLangDialogShow = false;
        },
        langDiolog() {
            let lang = store.state.checkLangs;

            AdventureManager.setLanguage(lang)
            this.$i18n.locale = lang;

            this.$nextTick(() => {
                // 如果是通过网址设定的，同时修改网址里的语言， 同时重新加载
                window.location.href = window.location.href.replace(
                    "language=" + AdventureManager.getLanguage(),
                    "language=" + lang
                );
                // window.location.reload();
            });
        },
        //胜利弹窗 确认
        adoptRightBtn() {
            $("button").attr("disabled", "disabled");
            AdventureManager.sendToGame("nextPass");
            Logger.log("store.state.Workspace对象====", store.state.Workspace);
            if (!Object.getOwnPropertyNames(store.state.Workspace)) {
                store.state.Workspace.clear();
            }
            store.state.blPython = "";
            store.state.xml_text = "";
            store.state.maskBox = false;
            store.state.ideMask = false;
            store.state.adoptDialog = false;
            store.state.adoptChinaDialog = false;
            store.state.currentIndex = false;
            $("#CanvasFrame").focus();
        },
        exitHandler() {
            if (store.state.competeType == Const.COMPETE_TYPE_TOUR) {
                store.state.tourNotCompelete = true;
                store.state.customeType = 'TourNotComplete';
                return;
            }
            this.goToNextStage();
            store.state.skipStyleShow = false;
            store.state.skipShow = false;
            store.state.maskBox = false;
            store.state.ideMask = false;
            store.state.adoptDialog = false;
            store.state.adoptChinaDialog = false;
            store.state.currentIndex = false;
            store.state.toBack = true;
            AdventureManager.sendToGame("exitGame");
        },
        //胜利弹窗 取消
        adoptLeftBtn() {
            store.state.codeShow = false;
            store.state.blPython = "";
            store.state.xml_text = "";
            if (store.state.justLastLevel && store.state.selectedPoint == store.state.maxHighlevel) {
                store.state.skipNextShow = true;
                store.state.adoptDialog = false;
                $("#CanvasFrame").focus();
                return;
            }
            if (store.state.isLastLevel) {
                store.state.maskBox = false;
                store.state.ideMask = false;
                store.state.adoptDialog = false;
                store.state.adoptChinaDialog = false;
                store.state.currentIndex = false;
                // 如果是体验关卡
                if (store.state.competeType == Const.COMPETE_TYPE_TOUR) {
                    if (store.state.isPassAllLevel <= 0) {
                        store.state.tourGameNotPass = true;
                        return;
                    }
                    let alllevels = window.bridge.getTotalLevel(1);
                    // 最后一关。分数有达到20分，并且通关，
                    if (store.state.isPassAllLevel >= 1 && (alllevels * 2) <= store.state.totalScore) {
                        store.state.tourCompelete = true;
                        store.state.customeType = 'PassTourAllLevel';
                        return;
                    }
                    store.state.tourCompeleteNotGet = true;
                    store.state.customeType = 'TourNotComplete';
                    return;
                }
                this.goToNextStage();
            } else {
                this.skipNextMethod();
            }
        },
        goToNextStage() {
            $("#CanvasFrame").focus();
            AdventureManager.sendToGame("nextPass");
        },
        skipNextBtn() {
            this.skipNextMethod();
            store.state.skipNextShow = false;
        },
        //回到过去弹窗
        skipNextMethod() {
            AdventureManager.sendToGame("goBack");
            store.state.maskBox = false;
            store.state.ideMask = false;
            store.state.adoptDialog = false;
            $("#CanvasFrame").focus();
        },
        continueCurrentTourHandler() {
            window.location.reload();
        },
        //错误弹窗 取消
        failCancelClick() {
            store.state.skipStyleShow = true;
            if (store.state.customeType == "ResetCode") {
                // store.state.skipStyleShow = false;
            } else if (store.state.customeType == "ExitGame") {
                store.state.ideMask = false;
            } else if (store.state.customeType == "Glossary") {
                store.state.ideMask = false;
            } else if (store.state.customeType == "PassAllLevel") {
                store.state.ideMask = false;
                this.logOut();
            } else {
                store.state.ideMask = false;
                AdventureManager.sendToGame("goBack");
            }
            store.state.maskBox = false;
            store.state.failDialog = false;
            store.state.failDialogChina = false;
            store.state.exitGameMode = false;
            store.state._resetCodeOpened = false;
            setTimeout(() => {
                store.state.toBack = false;
            }, 500);
            store.state.customeType == null;
            $("#CanvasFrame").focus();
        },
        failAcceptSkip() {
            store.state.blPython = "";
            store.state.xml_text = "";
            $("button").attr("disabled", "disabled");
            AdventureManager.sendToGame("skipToNext");
            if (store.state.chooseMode == "0") {
                store.state.Workspace.clear();
            }
            store.state.maskBox = false;
            store.state.ideMask = false;
            store.state.failDialog = false;
            store.state.failDialogChina = false;
            store.state.exitGameMode = false;
            store.state.currentIndex = true;
        },

        // 中文版本 最后成功
        failCancelClickChina() {
            store.state.ideMask = false;
            store.state.maskBox = false;
            store.state.adoptChinaDialog = false;
            AdventureManager.checkPonit(store.state.selectedPoint);
        },

        //错误弹窗 确认
        failAcceptClick() {
            store.state.blPython = "";
            store.state.xml_text = "";
            store.state.skipStyleShow = true;
            store.state.skipShow = true;

            if (store.state.customeType == "ResetCode") {
                // 如果配置了新的默认代码，使用新的默认代码
                if(this.$refs.idebox.GameLevelSetting.defaultCode) {
                    this.$refs.idebox.editor.setValue(
                        this.$refs.idebox.GameLevelSetting.defaultCode
                    );
                } else {
                    AdventureManager.sendToGame("acceptRestCodeDialog");
                }

            } else if (store.state.customeType == "ExitGame") {
                this.logOut();
            } else if (store.state.customeType == "Glossary") {
                Logger.log("Glossary");
            } else if (store.state.customeType == "PassAllLevel") {
                this.logOut();
            } else {
                AdventureManager.sendToGame("goBack");
            }
            setTimeout(() => {
                store.state.toBack = false;
            }, 500);
            store.state.maskBox = false;
            store.state.ideMask = false;
            store.state.failDialog = false;
            store.state.failDialogChina = false;
            store.state._resetCodeOpened = false;
            store.state.customeType == null;
            $("#CanvasFrame").focus();
        },

        // 关闭提示
        codeIndexDialogClose() {
            store.state.maskBox = false;
            store.state.codeIndexDialog = false;
        },
        //
        explainDialogHide() {
            store.state.explainDialog = false;
        },
        logOut() {
            let url = AdventureManager.getHomePage();
            window.location.href = url;
            // window.close();
        },
        sessionOut() {
            window.location.href = "about:blank";
            window.close();
        },
        linkToPub() {
            // window.location.href = 'https://pub.skillz-edu.org/portal/';
            window.location.href = AdventureManager.getSignPage();
        },
        linkToMonthly() {
            window.location.href = process.env.GAME_MONTH_URL;
        },
        linkToFinals() {
            window.location.href = AdventureManager.getFinalPage();
        },
        ended() {
            store.state.videoShow = false;
        },
        delVideo() {
            $(".videoShow").remove();
            store.state.videoShow = false;
            store.state.maskBox = false;
        },
        openVideo() {
            var video = document.getElementById("video");
            video.play();
        },
        exitBrower() {
            window.location.href = "about:blank";
            window.close();
        },
        playVideo() {
            this.playVideoShow = false;
            this.openVideo();
        },

        delPassAll() {
            store.state.passAllLevelShow = false;
            AdventureManager.getGameInfo();
            setTimeout(() => {
                store.state.qrCodeShow2 = false;
            }, 500);
        },
        interfaceAgian() {
            OperateDom.getStyle(
                this.$refs.interfaceErrorBtn,
                `${this.IMG_BASE_URL}shadow_reload.png`
            );
            setTimeout(() => {
                window.location.reload();
                store.state.interfaceErrorShow = false;
            }, 1000);
        },
        // listen event
        onPlayerPlay(player) {
            // console.log('player play!', player)
        },
        onPlayerPause(player) {
            // console.log('player pause!', player)
        },
        onPlayerEnded(player) {
            // console.log('player ended!', player)
        },
        onPlayerLoadeddata(player) {
            // console.log('player Loadeddata!', player)
        },
        onPlayerWaiting(player) {
            // console.log('player Waiting!', player)
        },
        onPlayerPlaying(player) {
            // console.log('player Playing!', player)
        },
        onPlayerTimeupdate(player) {
            // console.log('player Timeupdate!', player.currentTime())
        },
        onPlayerCanplay(player) {
            // console.log('player Canplay!', player)
        },
        onPlayerCanplaythrough(player) {
            player.play();
        },
        // or listen state event
        playerStateChanged(playerCurrentState) {
        },
        // player is ready
        playerReadied(player) {
            // seek to 10s
            Logger.log('example player 1 readied', player)
            player.currentTime(10)
        },
        continueCurrentTour(value) {
            store.state.tourNotCompelete = false;
            store.state.tourCompeleteNotGet = false;
            store.state.tourGameNotPass = false;
            if (value == 1) {
                AdventureManager.sendToGame("nextPass");
                Logger.log("continue current game");
            }
        },
        quitCurrentToure(value) {
            Logger.log("quitCurrentToure " + value);
            if (value == 1) {
                // 成功创关,领奖
                // goto tour main page
                window.location.href = process.env.ONE_HOUR_GET_PRIZE_URL + "?game=" + window.bridge.getCurrentGameId();
                return;
            }
            window.location.href = process.env.ONE_HOUR_URL;
            //goto tour main page
        },

        // fetchGameConfig() {
        //     let jsonFile = `./GameConfig/${store.state.gameId}.json`;
      
        //     fetch(jsonFile)
        //         .then(res => res.json())
        //         .then(data => {
        //             store.state.GameConfig = data;
        //             this.$refs.idebox.updateGameLevelSetting();
        //         })
        //         .catch(error => console.error('Error loading JOSN:', error));
        // },

        updateGameLevelSetting() {
            this.$refs.idebox.updateGameLevelSetting();
        },

        getFirstVideoUrl() {
            return `${location.origin}/static/video/${store.state.lang}/video01.mp4`;
        }
        
    },
    computed: {
        ...mapGetters([
            "maskBox",
            "adoptDialog",
            "failDialog",
            "adoptTitle",
            "adoptText",
            "failTitle",
            "failText",
            "customeType",
            "isLoading",
            "imagesLoaded",
            "loadingText",
            "codeIndexDialog",
            "allImageMap",
            "allArr",
            "adoptChinaDialog",
            "failDialogChina",
            "exitGameMode",
            "checkpointShow",
            "explainDialog",
            "configLine",
            "configSteps",
            "curLine",
            "curSteps",
            "star",
            "toBack",
            "skipShow",
            "knowledgeArr",
            "allStar",
            "dirLang",
            "sessionShow",
            "explainDialog1",
            "explainDialog2",
            "videoShow",
            "checkLangShow",
            "highCheckShow",
            "imgShow",
            "imgList",
            "browserVersionShow",
            "lang",
            "passAllLevelShow",
            "interfaceErrorShow",
            "isPassAllLevel",
            "skipStyleShow",
            "skipNextShow",
            "qrCodeUrl",
            "qrCodeShow",
            "getQRcode",
            "qrCodeShow2",
            "codeShow",
            "chooseMode",
            "blocklyShow",
            "justLastLevel",
            "checkLangDialogShow",
            "checkLangs",
            "monthlyGameShow",
            "ipShow",
            "timeoverShow",
            "isVip",
            "tourNotCompelete",
            "tourCompelete",
            "tourCompeleteNotGet",
            "tourGameNotPass",
            "pathAllImage",
            "isLastLevel"
        ]),
        delVideos() {
            if (window.screenLeft == 0 && window.document.body.clientWidth == window.screen.width) {
                return false;
            }
            return true;
        },
        qrCodeUrlM() {
            return store.state.qrCodeUrl;
        },
        zhShow() {
            if (store.state.lang == "en") {
                return false;
            } else {
                return true;
            }
        },
    },
};


// WEBPACK FOOTER //
// ./src/components/online-class.js